module.exports = __webpack_public_path__ + "static/media/utilitario.5c2ff845.svg";